/* City -> country index for predictive search.
   Keys are lowercase city names; values must match the country wording used
   in your product titles (standard short names, e.g. "United States",
   "United Kingdom", "South Korea"). Covers all countries with their capital
   and major/tourist cities. A city that maps to a country you don't sell
   simply returns no results (and shows no hint), so extra entries are safe.
   To tweak a country's wording to match your product titles, edit its values. */
window.PHONELYNE_CITIES = {
  // ---------------------------------------------------------------- Europe
  "tirana": "Albania", "durres": "Albania", "sarande": "Albania", "vlore": "Albania",
  "andorra la vella": "Andorra",
  "vienna": "Austria", "salzburg": "Austria", "innsbruck": "Austria", "graz": "Austria", "hallstatt": "Austria",
  "minsk": "Belarus",
  "brussels": "Belgium", "antwerp": "Belgium", "bruges": "Belgium", "ghent": "Belgium",
  "sarajevo": "Bosnia and Herzegovina", "mostar": "Bosnia and Herzegovina",
  "sofia": "Bulgaria", "plovdiv": "Bulgaria", "varna": "Bulgaria", "burgas": "Bulgaria",
  "zagreb": "Croatia", "dubrovnik": "Croatia", "split": "Croatia", "hvar": "Croatia", "zadar": "Croatia", "rovinj": "Croatia",
  "nicosia": "Cyprus", "limassol": "Cyprus", "paphos": "Cyprus", "ayia napa": "Cyprus",
  "prague": "Czechia", "brno": "Czechia", "cesky krumlov": "Czechia",
  "copenhagen": "Denmark", "aarhus": "Denmark", "odense": "Denmark",
  "tallinn": "Estonia", "tartu": "Estonia",
  "helsinki": "Finland", "rovaniemi": "Finland", "tampere": "Finland", "turku": "Finland",
  "paris": "France", "nice": "France", "lyon": "France", "marseille": "France", "bordeaux": "France",
  "cannes": "France", "toulouse": "France", "strasbourg": "France", "lille": "France", "nantes": "France", "chamonix": "France",
  "tbilisi": "Georgia", "batumi": "Georgia",
  "berlin": "Germany", "munich": "Germany", "frankfurt": "Germany", "hamburg": "Germany",
  "cologne": "Germany", "dusseldorf": "Germany", "stuttgart": "Germany", "dresden": "Germany", "nuremberg": "Germany",
  "athens": "Greece", "santorini": "Greece", "mykonos": "Greece", "thessaloniki": "Greece",
  "crete": "Greece", "corfu": "Greece", "rhodes": "Greece", "heraklion": "Greece", "zakynthos": "Greece",
  "budapest": "Hungary", "debrecen": "Hungary",
  "reykjavik": "Iceland", "akureyri": "Iceland",
  "dublin": "Ireland", "cork": "Ireland", "galway": "Ireland", "killarney": "Ireland",
  "rome": "Italy", "milan": "Italy", "venice": "Italy", "florence": "Italy", "naples": "Italy",
  "turin": "Italy", "bologna": "Italy", "pisa": "Italy", "amalfi": "Italy", "verona": "Italy",
  "genoa": "Italy", "palermo": "Italy", "sorrento": "Italy", "sicily": "Italy",
  "pristina": "Kosovo",
  "riga": "Latvia",
  "vaduz": "Liechtenstein",
  "vilnius": "Lithuania", "kaunas": "Lithuania",
  "luxembourg": "Luxembourg",
  "valletta": "Malta", "sliema": "Malta",
  "chisinau": "Moldova",
  "monaco": "Monaco", "monte carlo": "Monaco",
  "podgorica": "Montenegro", "kotor": "Montenegro", "budva": "Montenegro",
  "amsterdam": "Netherlands", "rotterdam": "Netherlands", "the hague": "Netherlands", "utrecht": "Netherlands", "eindhoven": "Netherlands",
  "skopje": "North Macedonia", "ohrid": "North Macedonia",
  "oslo": "Norway", "bergen": "Norway", "tromso": "Norway", "stavanger": "Norway", "trondheim": "Norway",
  "warsaw": "Poland", "krakow": "Poland", "gdansk": "Poland", "wroclaw": "Poland", "poznan": "Poland",
  "lisbon": "Portugal", "porto": "Portugal", "faro": "Portugal", "madeira": "Portugal", "algarve": "Portugal", "sintra": "Portugal",
  "bucharest": "Romania", "cluj-napoca": "Romania", "brasov": "Romania", "transylvania": "Romania",
  "moscow": "Russia", "saint petersburg": "Russia", "st petersburg": "Russia", "sochi": "Russia", "kazan": "Russia",
  "san marino": "San Marino",
  "belgrade": "Serbia", "novi sad": "Serbia",
  "bratislava": "Slovakia", "kosice": "Slovakia",
  "ljubljana": "Slovenia", "bled": "Slovenia", "piran": "Slovenia",
  "madrid": "Spain", "barcelona": "Spain", "seville": "Spain", "valencia": "Spain", "malaga": "Spain",
  "ibiza": "Spain", "granada": "Spain", "bilbao": "Spain", "mallorca": "Spain", "marbella": "Spain", "tenerife": "Spain",
  "stockholm": "Sweden", "gothenburg": "Sweden", "malmo": "Sweden", "uppsala": "Sweden",
  "zurich": "Switzerland", "geneva": "Switzerland", "lucerne": "Switzerland",
  "interlaken": "Switzerland", "zermatt": "Switzerland", "bern": "Switzerland", "basel": "Switzerland", "lausanne": "Switzerland",
  "kyiv": "Ukraine", "kiev": "Ukraine", "lviv": "Ukraine", "odesa": "Ukraine", "odessa": "Ukraine",
  "london": "United Kingdom", "manchester": "United Kingdom", "edinburgh": "United Kingdom",
  "glasgow": "United Kingdom", "liverpool": "United Kingdom", "birmingham": "United Kingdom",
  "bristol": "United Kingdom", "belfast": "United Kingdom", "oxford": "United Kingdom",
  "cambridge": "United Kingdom", "cardiff": "United Kingdom", "leeds": "United Kingdom",
  "vatican city": "Vatican City",

  // -------------------------------------------------------- Middle East
  "yerevan": "Armenia",
  "baku": "Azerbaijan",
  "manama": "Bahrain",
  "cairo": "Egypt", "luxor": "Egypt", "hurghada": "Egypt", "sharm el sheikh": "Egypt", "alexandria": "Egypt", "aswan": "Egypt",
  "tehran": "Iran", "isfahan": "Iran", "shiraz": "Iran",
  "baghdad": "Iraq", "erbil": "Iraq",
  "tel aviv": "Israel", "jerusalem": "Israel", "haifa": "Israel", "eilat": "Israel",
  "amman": "Jordan", "petra": "Jordan", "aqaba": "Jordan",
  "kuwait city": "Kuwait",
  "beirut": "Lebanon",
  "muscat": "Oman", "salalah": "Oman",
  "doha": "Qatar",
  "riyadh": "Saudi Arabia", "jeddah": "Saudi Arabia", "mecca": "Saudi Arabia", "medina": "Saudi Arabia",
  "damascus": "Syria",
  "istanbul": "Turkey", "antalya": "Turkey", "izmir": "Turkey", "ankara": "Turkey",
  "cappadocia": "Turkey", "bodrum": "Turkey", "fethiye": "Turkey", "marmaris": "Turkey",
  "dubai": "United Arab Emirates", "abu dhabi": "United Arab Emirates", "sharjah": "United Arab Emirates", "ras al khaimah": "United Arab Emirates",
  "sanaa": "Yemen",

  // ------------------------------------------------------------- Asia
  "kabul": "Afghanistan",
  "dhaka": "Bangladesh", "chittagong": "Bangladesh",
  "thimphu": "Bhutan", "paro": "Bhutan",
  "bandar seri begawan": "Brunei",
  "phnom penh": "Cambodia", "siem reap": "Cambodia", "angkor wat": "Cambodia",
  "beijing": "China", "shanghai": "China", "guangzhou": "China", "shenzhen": "China",
  "chengdu": "China", "xian": "China", "hangzhou": "China", "guilin": "China",
  "hong kong": "Hong Kong",
  "macau": "Macau",
  "delhi": "India", "new delhi": "India", "mumbai": "India", "goa": "India", "bangalore": "India",
  "jaipur": "India", "agra": "India", "kolkata": "India", "chennai": "India", "hyderabad": "India", "kerala": "India",
  "jakarta": "Indonesia", "bali": "Indonesia", "ubud": "Indonesia", "yogyakarta": "Indonesia", "surabaya": "Indonesia", "lombok": "Indonesia",
  "tokyo": "Japan", "osaka": "Japan", "kyoto": "Japan", "hokkaido": "Japan", "okinawa": "Japan",
  "nagoya": "Japan", "sapporo": "Japan", "fukuoka": "Japan", "hiroshima": "Japan", "nara": "Japan",
  "almaty": "Kazakhstan", "astana": "Kazakhstan", "nur-sultan": "Kazakhstan",
  "bishkek": "Kyrgyzstan",
  "vientiane": "Laos", "luang prabang": "Laos",
  "kuala lumpur": "Malaysia", "penang": "Malaysia", "langkawi": "Malaysia", "malacca": "Malaysia", "kota kinabalu": "Malaysia",
  "male": "Maldives",
  "ulaanbaatar": "Mongolia",
  "yangon": "Myanmar", "mandalay": "Myanmar", "bagan": "Myanmar",
  "kathmandu": "Nepal", "pokhara": "Nepal",
  "pyongyang": "North Korea",
  "karachi": "Pakistan", "lahore": "Pakistan", "islamabad": "Pakistan",
  "manila": "Philippines", "cebu": "Philippines", "boracay": "Philippines", "palawan": "Philippines", "davao": "Philippines",
  "singapore": "Singapore",
  "seoul": "South Korea", "busan": "South Korea", "jeju": "South Korea", "incheon": "South Korea",
  "colombo": "Sri Lanka", "kandy": "Sri Lanka", "galle": "Sri Lanka",
  "taipei": "Taiwan", "kaohsiung": "Taiwan", "taichung": "Taiwan",
  "dushanbe": "Tajikistan",
  "bangkok": "Thailand", "phuket": "Thailand", "chiang mai": "Thailand", "krabi": "Thailand",
  "pattaya": "Thailand", "koh samui": "Thailand", "ko samui": "Thailand", "phi phi": "Thailand",
  "ashgabat": "Turkmenistan",
  "tashkent": "Uzbekistan", "samarkand": "Uzbekistan", "bukhara": "Uzbekistan",
  "hanoi": "Vietnam", "ho chi minh city": "Vietnam", "saigon": "Vietnam", "da nang": "Vietnam",
  "hoi an": "Vietnam", "nha trang": "Vietnam", "hue": "Vietnam", "ha long": "Vietnam",

  // ------------------------------------------------------------ Africa
  "algiers": "Algeria", "oran": "Algeria",
  "luanda": "Angola",
  "cotonou": "Benin",
  "gaborone": "Botswana",
  "ouagadougou": "Burkina Faso",
  "bujumbura": "Burundi",
  "praia": "Cape Verde",
  "yaounde": "Cameroon", "douala": "Cameroon",
  "bangui": "Central African Republic",
  "ndjamena": "Chad",
  "moroni": "Comoros",
  "brazzaville": "Republic of the Congo",
  "kinshasa": "Democratic Republic of the Congo",
  "djibouti": "Djibouti",
  "cairo egypt": "Egypt",
  "malabo": "Equatorial Guinea",
  "asmara": "Eritrea",
  "mbabane": "Eswatini",
  "addis ababa": "Ethiopia",
  "libreville": "Gabon",
  "banjul": "Gambia",
  "accra": "Ghana", "kumasi": "Ghana",
  "conakry": "Guinea",
  "bissau": "Guinea-Bissau",
  "abidjan": "Ivory Coast", "yamoussoukro": "Ivory Coast",
  "nairobi": "Kenya", "mombasa": "Kenya", "maasai mara": "Kenya",
  "maseru": "Lesotho",
  "monrovia": "Liberia",
  "tripoli": "Libya",
  "antananarivo": "Madagascar",
  "lilongwe": "Malawi", "blantyre": "Malawi",
  "bamako": "Mali",
  "nouakchott": "Mauritania",
  "port louis": "Mauritius",
  "rabat": "Morocco", "marrakech": "Morocco", "casablanca": "Morocco", "fes": "Morocco", "tangier": "Morocco", "agadir": "Morocco",
  "maputo": "Mozambique",
  "windhoek": "Namibia",
  "niamey": "Niger",
  "lagos": "Nigeria", "abuja": "Nigeria", "port harcourt": "Nigeria", "kano": "Nigeria", "ibadan": "Nigeria",
  "kigali": "Rwanda",
  "sao tome": "Sao Tome and Principe",
  "dakar": "Senegal",
  "victoria": "Seychelles",
  "freetown": "Sierra Leone",
  "mogadishu": "Somalia",
  "cape town": "South Africa", "johannesburg": "South Africa", "durban": "South Africa",
  "pretoria": "South Africa", "port elizabeth": "South Africa", "kruger": "South Africa",
  "juba": "South Sudan",
  "khartoum": "Sudan",
  "dar es salaam": "Tanzania", "zanzibar": "Tanzania", "arusha": "Tanzania", "dodoma": "Tanzania",
  "lome": "Togo",
  "tunis": "Tunisia", "sousse": "Tunisia", "hammamet": "Tunisia",
  "kampala": "Uganda",
  "lusaka": "Zambia", "livingstone": "Zambia",
  "harare": "Zimbabwe", "victoria falls": "Zimbabwe",

  // -------------------------------------------------- North & Central America
  "nassau": "Bahamas",
  "bridgetown": "Barbados",
  "belize city": "Belize", "san pedro": "Belize",
  "toronto": "Canada", "vancouver": "Canada", "montreal": "Canada", "calgary": "Canada",
  "ottawa": "Canada", "quebec city": "Canada", "banff": "Canada", "niagara falls": "Canada",
  "san jose": "Costa Rica", "tamarindo": "Costa Rica",
  "havana": "Cuba", "varadero": "Cuba",
  "roseau": "Dominica",
  "santo domingo": "Dominican Republic", "punta cana": "Dominican Republic",
  "san salvador": "El Salvador",
  "st georges": "Grenada",
  "guatemala city": "Guatemala", "antigua guatemala": "Guatemala",
  "port-au-prince": "Haiti",
  "tegucigalpa": "Honduras", "roatan": "Honduras",
  "kingston": "Jamaica", "montego bay": "Jamaica",
  "mexico city": "Mexico", "cancun": "Mexico", "tulum": "Mexico", "playa del carmen": "Mexico",
  "cabo": "Mexico", "cabo san lucas": "Mexico", "puerto vallarta": "Mexico", "guadalajara": "Mexico", "oaxaca": "Mexico",
  "managua": "Nicaragua",
  "panama city": "Panama",
  "san juan": "Puerto Rico",
  "basseterre": "Saint Kitts and Nevis",
  "castries": "Saint Lucia",
  "kingstown": "Saint Vincent and the Grenadines",
  "port of spain": "Trinidad and Tobago",
  "new york": "United States", "los angeles": "United States", "san francisco": "United States",
  "las vegas": "United States", "miami": "United States", "chicago": "United States",
  "orlando": "United States", "boston": "United States", "seattle": "United States",
  "washington": "United States", "honolulu": "United States", "new orleans": "United States",
  "san diego": "United States", "austin": "United States", "atlanta": "United States",
  "dallas": "United States", "houston": "United States", "denver": "United States", "hawaii": "United States",

  // ---------------------------------------------------------- South America
  "buenos aires": "Argentina", "mendoza": "Argentina", "bariloche": "Argentina", "cordoba": "Argentina",
  "la paz": "Bolivia", "santa cruz": "Bolivia", "uyuni": "Bolivia",
  "rio de janeiro": "Brazil", "sao paulo": "Brazil", "salvador": "Brazil", "brasilia": "Brazil",
  "fortaleza": "Brazil", "florianopolis": "Brazil", "foz do iguacu": "Brazil",
  "santiago": "Chile", "valparaiso": "Chile", "atacama": "Chile", "patagonia": "Chile",
  "bogota": "Colombia", "medellin": "Colombia", "cartagena": "Colombia", "cali": "Colombia",
  "quito": "Ecuador", "guayaquil": "Ecuador", "galapagos": "Ecuador",
  "georgetown": "Guyana",
  "asuncion": "Paraguay",
  "lima": "Peru", "cusco": "Peru", "machu picchu": "Peru", "arequipa": "Peru",
  "paramaribo": "Suriname",
  "montevideo": "Uruguay", "punta del este": "Uruguay",
  "caracas": "Venezuela",

  // -------------------------------------------------------- Oceania
  "sydney": "Australia", "melbourne": "Australia", "brisbane": "Australia", "perth": "Australia",
  "gold coast": "Australia", "cairns": "Australia", "adelaide": "Australia", "canberra": "Australia", "tasmania": "Australia",
  "suva": "Fiji", "nadi": "Fiji",
  "tarawa": "Kiribati",
  "majuro": "Marshall Islands",
  "palikir": "Micronesia",
  "auckland": "New Zealand", "queenstown": "New Zealand", "wellington": "New Zealand",
  "christchurch": "New Zealand", "rotorua": "New Zealand",
  "ngerulmud": "Palau", "koror": "Palau",
  "port moresby": "Papua New Guinea",
  "apia": "Samoa",
  "honiara": "Solomon Islands",
  "nukualofa": "Tonga",
  "funafuti": "Tuvalu",
  "port vila": "Vanuatu"
};

// Country-name variants treated as the same country when searching, so a plan
// titled "UAE" still matches "United Arab Emirates" (and vice versa), etc.
window.PHONELYNE_ALIASES = {
  "uae": "united arab emirates",
  "u.a.e.": "united arab emirates",
  "emirates": "united arab emirates",
  "usa": "united states",
  "u.s.a.": "united states",
  "u.s.": "united states",
  "us": "united states",
  "united states of america": "united states",
  "america": "united states",
  "uk": "united kingdom",
  "u.k.": "united kingdom",
  "great britain": "united kingdom",
  "britain": "united kingdom",
  "england": "united kingdom",
  "czechia": "czech republic",
  "holland": "netherlands",
  "turkiye": "turkey"
};
